import { render } from "./AuthLayout.vue?vue&type=template&id=3904a1e2&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"

import "./AuthLayout.vue?vue&type=style&index=0&id=3904a1e2&scoped=true&lang=css"
import "./AuthLayout.vue?vue&type=style&index=1&id=3904a1e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3904a1e2"]])

export default __exports__